import { render } from "./UserMyCourse.vue?vue&type=template&id=a37b8f4e&scoped=true"
import script from "./UserMyCourse.vue?vue&type=script&lang=js"
export * from "./UserMyCourse.vue?vue&type=script&lang=js"

import "./user-course-responsive.css?vue&type=style&index=0&lang=css&external"
import "./UserMyCourse.vue?vue&type=style&index=1&id=a37b8f4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37b8f4e"]])

export default __exports__